import 'waypoints/lib/noframework.waypoints.min.js';

let isScroll = false;

const TOC_HEADER = document.querySelector('.toc--header');
const TOC_CONTENT = document.querySelector('.toc--content');
const HEADER = document.querySelector('.header');
let tocCurrent = null;

function checkScroll() {
    if (!isScroll) {
        requestAnimationFrame(update);
    }
    isScroll = true;
}

window.emitter.on('jumped', event => {
    const TARGET = event.target.closest('.section');
    if (TARGET) {
        const text = TARGET.querySelector('.section__title small').innerHTML;
        setTimeout(() => {
            // Force text
            waypointHandler(TARGET.id, text);
        }, 10);
    }
});

function update() {
    isScroll = false;
    let headerBottom = HEADER.getBoundingClientRect().bottom;
    headerBottom = headerBottom < 0 ? 0 : headerBottom;
    let isOutOfView = headerBottom >= TOC_CONTENT.getBoundingClientRect().bottom;
    TOC_HEADER.classList[isOutOfView ? 'add' : 'remove']('toc--active');
    document.documentElement.classList[isOutOfView ? 'add' : 'remove']('-toc--active');

    if (!isOutOfView) {
        history.replaceState({}, null, document.location.href.split('#')[0]);
    }
}

function waypointHandler(id, text) {
    history.replaceState({}, null, `#${id}`);
    tocCurrent.innerHTML = text;
}

if (TOC_HEADER && TOC_CONTENT && HEADER) {
    const WAYPOINT = [];
    tocCurrent = TOC_HEADER.querySelector('.toc__current');

    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    [...document.querySelectorAll('section.section')].forEach(element => {
        let id = element.id;
        let text = element.querySelector('.section__title small').innerHTML;
        WAYPOINT.push({
            element,
            id,
            text
        });
    });

    if (!document.body.classList.contains('neos-backend')) {
        WAYPOINT.forEach(({ element, id, text }) => {
            // Scrolling down
            new Waypoint({
                element: element,
                offset: 200,
                handler: direction => {
                    if (direction == 'down') {
                        waypointHandler(id, text);
                    }
                }
            });
            // Scrolling up
            new Waypoint({
                element: element,
                offset: function() {
                    return this.context.innerHeight() - this.adapter.outerHeight() - 200;
                },
                handler: direction => {
                    if (direction == 'up') {
                        waypointHandler(id, text);
                    }
                }
            });
        });

        document.addEventListener('lazyloaded', () => {
            Waypoint.refreshAll();
        });
    }
}
